import {Modal, Button} from 'react-bootstrap';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@mui/material/Alert';
export default function  Alert ({show,handleClose}) {
    return (
        <>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Body className='alert alert-warning'>Veuiller reduire la taille des fichiers</Modal.Body>
            </Modal>
        </>
    )
}
export function Alert2({message}) {
    const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
    return (
      <>
        <Modal  backdrop="static" show={show} onHide={handleClose} centered >
          <Modal.Body >{message}</Modal.Body>
          <Modal.Footer>
          <Link to='/'>
              <Button variant="" onClick={handleClose}>
                Fermer
              </Button>
              </Link>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
export function Alert3({message}) {
    const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
    return (
      <>
        <Modal  show={show} onHide={handleClose} centered >
          <Modal.Body >{message}</Modal.Body>
          <Modal.Footer>
          <Button variant="" onClick={handleClose}>
              <a href="https://etudiant.uam.sn/user/preinscription" target="_blank" rel="noopener noreferrer" style={{textDecoration:'none', color:'#fff'}}>
                Préinscription
              </a>
          </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
export function  Alerte ({open , handleClose, message})  {
  return (
    <>
      <Snackbar open={open} autoHideDuration={4000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} onClose={handleClose}>
          <MuiAlert onClose={handleClose} elevation={6} severity="error" sx={{ width: '100%' }}>
          {message}
          </MuiAlert>
      </Snackbar>
    </>
  )
}
  